import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import RootState from '../../redux/states/root.state';
import Spinner from "../common/Spinner";
import AccessDenied from '../../pages/General/AccessDenied';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {
    const {data:user, accessToken, loading, refreshing} = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!accessToken && !loading && !refreshing) {
            navigate('/login', { state: { from: location.pathname + location.search }, replace: true });
        }
    }, [accessToken, refreshing, user, navigate, location]);

    return (accessToken && user) ? <>{children}</> : (loading || refreshing || !user) ? <Spinner /> : <AccessDenied/>

};

export default ProtectedRoute;